/**
 * Table slice — holds the currently selected row's id and data for simple table
 * interactions. For DTS-scoped grid selections (per-tab selected rows) use
 * detailsTabStripsSlice.selectedRowsByDts instead; this slice is for generic,
 * non-DTS table state shared across multiple consumers.
 */
import { createSlice } from '@reduxjs/toolkit'
import { SLICE_BASE_NAME } from './constants'

export type TableState = {
    rowId?: number
    data?: object
    rowData?: object
}

const initialState: TableState = {
    rowId: 0,
    data: {},
    rowData: {},
}

export const tableSlice = createSlice({
    name: `${SLICE_BASE_NAME}/table`,
    initialState,
    reducers: {
        setRowId: (state, action) => {
            state.rowId = action.payload
        },
        setData: (state, action) => {
            state.data = action.payload
        },
        setRowdata: (state, action) => {
            state.rowData = action.payload
        },
    },
})

export const { setRowId, setData, setRowdata } = tableSlice.actions

export default tableSlice.reducer
